import {useState} from "react";
import React from "react";
import icons from "../helpers/icons";
import {extractDateAndMonth, extractYear} from '../helpers/util';
import VismerKnappen from '../components/VismerKnappen';


const Utstillingsresultater = (props) => {

    const [resultaterVises, setResultaterVises] = useState(5)

    const resultater = props.resultater || [];

    const rows = resultater
        .map((resultat) => (
            <Resultat key={resultat.id} resultat={resultat} />
        ))
        .splice(0, resultaterVises);

    return (
        <div className="dogweb-utstilling">

            {rows}
            {resultater.length === 0 &&
                <div>&nbsp;</div>
            }

            <VismerKnappen
                total={resultater.length}
                maxStep="5"
                renderedAmount={resultaterVises}
                incrementer={setResultaterVises}
            />
        </div>
    );
};

const Resultat = (props) => {
    const resultat = props.resultat;
    const [showDetaljer, setShowDetaljer] = useState(false);
    const [showKritikk, setShowKritikk] = useState(false);

    const toggleKritikk = () => {
        if (showKritikk) {
            setShowKritikk(false);
        } else {
            setShowKritikk(true);
        }
    };

    const toggleDetaljer = () => {
        if (showDetaljer) {
            setShowDetaljer(false);
        }else {
            setShowDetaljer(true);
        }
    }

    function bedommelseDato(){
        if (resultat.bedoemmelseDato !== null) return resultat.bedoemmelseDato;
        else {
            if (resultat.fra !== null) return resultat.fra;
            else if (resultat.til !== null) return resultat.til;
        }
        return null;
    }

    const detaljer = (
        <div className="line-info" >
            <div className="splitt-line"></div>
            <ul className="dogweb-details">
                <li><a href={resultat.resultatUrl} className="document-link" rel="noopener noreferrer" target="_blank">Se racens resultater</a></li>

                { resultat.kritikk !== null &&
                    <li>
                        <button onClick={toggleKritikk} className="kritikk-button">Se kritik</button>
                        {
                            showKritikk &&
                                <div>
                                    <span>{resultat.kritikk}</span>
                                    { resultat.pdfKritikkUrl !== null &&
                                        <span>
                                            <br/>
                                            <a href={resultat.pdfKritikkUrl} className="document-link" rel="noopener noreferrer" target="_blank">PDF Kritik</a>
                                        </span>
                                    }
                                </div>
                        }
                    </li>
                }
            </ul>
        </div>

    );

   function getDommer(){
       if (resultat.dommer)
        return <div style={{paddingLeft:0}}><span>Dommer:</span> {resultat.dommer}</div>
    }
    return (
        <div>
            <button onClick={toggleDetaljer} className="line">
                <div className="place">
                    <div className="date">{extractDateAndMonth(bedommelseDato())}</div>
                    <div className="location clip">{resultat.sted}</div>
                    <div className="score clip">
                            <span>
                                <img className="icon" src={icons.score} alt="" />
                            </span>
                        {resultat.resultatStreng}
                    </div>
                </div>
                <div className="club">
                    <div className="year">{extractYear(bedommelseDato())}</div>
                    <div className="club-name clip">{getDommer()}{resultat.arrangoerNavn}</div>
                    <div className="arrow">
                        <img className="icon" src={icons.acd} alt="" data-open={showDetaljer}/>
                    </div>
                </div>
            </button>
            { showDetaljer && detaljer}
        </div>
    );
};

export default Utstillingsresultater;
